import * as defaultImport from "react-dom";
export * from "react-dom";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
